import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BigPlayButton, Player } from 'video-react';
import flash from '../../images/AboutCompany/flash.png';
import office from '../../images/AboutCompany/office.png';
import people from '../../images/AboutCompany/people.png';
import support from '../../images/AboutCompany/support.png';
import video from '../../images/AboutCompany/video.mp4';
import './AboutCompany.scss';

const AboutCompany = () => {
    const companyData = [
        {
            id: 1,
            img: flash,
            title: '10+Fast Working Process',
            des: "mmy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the",
        },
        {
            id: 2,
            img: people,
            title: 'Dedicated Team',
            des: "mmy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the",
        },
        {
            id: 3,
            img: support,
            title: '24/7 Hours Support',
            des: "mmy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the",
        },
        {
            id: 4,
            img: flash,
            title: '10+Fast Working Process',
            des: "mmy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the",
        },
    ];

    return (
        <section className="about-company">
            <div className="company-heading">
                <Container>
                    <div data-aos="fade-right" data-aos-duration="1500">
                        <p>Why you should Use</p>
                        <h1>The #1 WordPress Service Company</h1>
                    </div>
                    <div data-aos="zoom-in" data-aos-duration="1500">
                        <Player
                            playsInline
                            fluid={false}
                            className="company-player"
                            poster={office}
                        >
                            <source src={video} type="video/mp4" />
                            <BigPlayButton position="center" />
                        </Player>
                    </div>
                </Container>
            </div>

            <div className="company-info">
                <Container>
                    <Row>
                        {companyData.map((company) => (
                            <Col
                                md={6}
                                className="d-flex align-items-center justify-content-center mb-2"
                                key={company.id}
                            >
                                <div className="company-info-card">
                                    <div
                                        className="info-img"
                                        data-aos="fade-down"
                                        data-aos-duration="1500"
                                    >
                                        <img src={company.img} alt="" />
                                    </div>
                                    <div
                                        className="info-details"
                                        data-aos="fade-up"
                                        data-aos-duration="1500"
                                    >
                                        <h5>{company.title}</h5>
                                        <p>{company.des}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
        </section>
    );
};

export default AboutCompany;
